import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { Slider } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CustomToast from "./CustomToast";
import ProductCard from "./ProductCard";
import { getCartItems } from "../api/Product.services";
import { Dropdown as BootstrapDropdown } from 'react-bootstrap';
import "./ProductsPage.css";

const API_BASE_URL = process.env.REACT_APP_BASE_URL;


function ProductsPage({ setCartItemsCount }) {
  const { category } = useParams();
  const [categoryText, setCategoryText] = useState('');
  const location = useLocation();
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [priceRange, setPriceRange] = useState([0, 10000]);
  const subCategory = location.state?.subCategory || null;
  const [subCategoryText, setSubCategoryText] = useState('');

  const toStartCase = (str) => {
    if (!str) return ''; 
    const trimmedStr = str.trim(); 
    const result = trimmedStr.charAt(0).toUpperCase() + trimmedStr.slice(1).toLowerCase();
    // console.log("Transformed string: ", result); 
    return result;
  };

  useEffect(() =>{
    let toTitleCase = toStartCase(category)
    // console.log("toTitleCase",toTitleCase);
    setCategoryText(toTitleCase);
  },[category])

  useEffect(() =>{
    setSubCategoryText(toStartCase(subCategory));
  },[subCategory])

  const handleCartSuccess = async (message) => {
    toast(<CustomToast message={`1 product`} />, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: false,
      pauseOnHover: true,
      draggable: false,
    });

    try {
      // Fetch updated cart items count after adding a product
      const response = await getCartItems();
      setCartItemsCount(response[0]?.items?.length || 0);
    } catch (error) {
      console.error("Error updating cart items:", error);
    }
  };

  const handleCartError = (message) => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
  };

  useEffect(() => {
    let isMounted = true;

    async function fetchProducts() {
      if (!category) return;
      setLoading(true);
      const baseUrl = `${API_BASE_URL}/product/products/`;
      const params = new URLSearchParams({
        category,
        ...(subCategory && { sub_category: subCategory }),
      });

      try {
        const response = await fetch(`${baseUrl}?${params.toString()}`);
        if (response.ok) {
          const data = await response.json();
          if (isMounted) {
            const transformedProducts = data.results.map((product) => ({
              id: product.id,
              name: product.name,
              image: product.picture,
              currentPrice: parseFloat(product.actual_unit_price),
              originalPrice: parseFloat(product.unit_price),
              discount: product.discount,
              labels: product.tags.map((tag) => tag.name),
              tagline: product.label.length > 0 ? product.label[0].name : "",
            }));
            setProducts(transformedProducts);
            setFilteredProducts(transformedProducts);
          }
        } else {
          throw new Error("Failed to fetch products");
        }
      } catch (error) {
        if (isMounted) setError(error.message);
      } finally {
        if (isMounted) setLoading(false);
      }
    }

    fetchProducts();
    return () => {
      isMounted = false;
    };
  }, [category, subCategory]);

  useEffect(() => {
    const filtered = products.filter(
      (product) =>
        product.currentPrice >= priceRange[0] &&
        product.currentPrice <= priceRange[1]
    );
    setFilteredProducts(filtered);
  }, [priceRange, products]);
  
  const handleSliderChange = (_, newValue) => {
    if (newValue[0] < newValue[1]) {
      setPriceRange(newValue);
    }
  };
  return (
    <div className="products-page">
      <ToastContainer />

      <div className="">
        <div className="d-flex flex-column flex-md-row justify-content-center align-items-center text-center pb-3">

          {/* <h3 className="category-title text-center flex-grow-1 mb-2 mb-md-0">{toTitleCase(category)}</h3> */}
        {/* JSX rendering */}
          {subCategoryText ? (
            <h3 className="category-title text-center flex-grow-1 mb-2 mb-md-0">
              {categoryText}   <span className="subCategoryText"> - {subCategoryText}</span>
            </h3>
          ) : (
            <h3 className="category-title text-center flex-grow-1 mb-2 mb-md-0">
              {categoryText}
            </h3>
          )}  
          <BootstrapDropdown>
            <BootstrapDropdown.Toggle
              variant="primary"
              id="priceFilterDropdown"
              className="filter-by-price-btn ms-0 px-3 py-2 small-btn"
            >
              Filter by Price
            </BootstrapDropdown.Toggle>
            <BootstrapDropdown.Menu className="p-3">
              <Slider
                value={priceRange}
                onChange={handleSliderChange}
                valueLabelDisplay="auto"
                min={0}
                max={15000}
                sx={{ color: "#d32f2f" }}
              />
              <div className="d-flex justify-content-between mt-2">
                <span>₹{priceRange[0]}</span>
                <span>₹{priceRange[1]}</span>
              </div>
            </BootstrapDropdown.Menu>
          </BootstrapDropdown>
        </div>
      </div>
      
      <div className="products-layout mt-4">
        <div className="container-fluid">
            {loading ? (
              <p>Loading products...</p>
            ) : error ? (
              <p className="error-message">{error}</p>
            ) : (
              <div className="row justify-content-center align-item-center ms-0 me-0 gy-3 gx-3">
                {filteredProducts.length > 0 ? (
                  filteredProducts.map((product) => (
                    // <div className="width-col-card">
                      <ProductCard
                        key={product.id}
                        product={product}
                        onCartError={handleCartError}
                        onCartSuccess={handleCartSuccess}
                      />
                    // </div>
                  ))
                ) : (
                  <p>No products available in this category.</p>
                )}
              </div>
            )}
        </div>
      </div>
    </div>
  );
}

export default ProductsPage;
